export default __webpack_public_path__ + "static/media/done1.e28e9187.jpg";